import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateOptions } from '../../../../../actions';
import { OVERLAY_PLACEMENTS } from '../../../../../constants/general';
import { useAnalytics } from '../../../../../hooks/useAnalytics';
import { useOptions } from '../../../../../selectors';
import { OverlayPlacementName } from '../../../../../types';
import { toggleAndKeepOne } from '../../../../../utils';
import { SelectablePlacementOption } from './SelectablePlacementOption';

export interface SelectablePlacementOptionWithHandlerProps {
  label: string,
  placement: OverlayPlacementName,
}

export const SelectablePlacementOptionWithHandler: FC<SelectablePlacementOptionWithHandlerProps> = ({ placement, label }) => {
  const analytics = useAnalytics();
  const dispatch = useDispatch();
  const { selectedOverlayPlacements } = useOptions();

  const handleChange = useCallback(() => {
    const newState = !selectedOverlayPlacements[placement];
    analytics('edit image overlay', `${newState ? 'enable' : 'disable'} ${placement}`);

    dispatch(updateOptions({
      selectedOverlayPlacements: toggleAndKeepOne(selectedOverlayPlacements, placement, true, OVERLAY_PLACEMENTS[0], OVERLAY_PLACEMENTS[1]),
    }));
  }, [analytics, dispatch, placement, selectedOverlayPlacements]);

  return (
    <SelectablePlacementOption
      isSelected={selectedOverlayPlacements[placement]}
      onClick={handleChange}
      placement={placement}
      label={label}
    />
  );
};
